import React, {useState, useEffect} from 'react';
import {
  Dialog,
  DialogContent,
  Checkbox,
  Grid,
  FormControlLabel
} from '@material-ui/core';
import { DialogTitle, LanguageString } from '../Common';
import { ROCType } from '../../dto';

interface RecordOfContactDialogProps {
  open: boolean;
  close: () => void;
  rocTypes: ROCType[];
  filteredIds: number[];
  setFilteredIds: (na: number[]) => void;
  resetPage: () => void;
}

export const RecordOfContactFilterDialog: React.FC<RecordOfContactDialogProps> = ({ open, close, rocTypes, filteredIds, setFilteredIds, resetPage}) => {
  const [tempFilteredIds, setTempFilteredIds] = useState<number[]>([]);

  useEffect(() => {
    setTempFilteredIds([...filteredIds]);
  }, [filteredIds]);

  const handleClose = () => {
    if (tempFilteredIds.length !== filteredIds.length || !tempFilteredIds.every(id => filteredIds.includes(id))) {
      setFilteredIds([...tempFilteredIds]);
      resetPage();
    }

    close();
  };

  return (
    <>
      <Dialog fullWidth open={open} onClose={handleClose} aria-labelledby="Record of Contact Form">
        <DialogTitle onClose={handleClose}>
          <LanguageString groupName="ROC" resourceName="ROC_FILTERS" defaultText="Filters" />
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={3}>
            {rocTypes?.map(rt => {
              return (
                <Grid item xs={12} md={4} style={{ borderBottom: '1px solid #ccc' }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={tempFilteredIds.includes(rt.id)}
                        value="primary"
                        onChange={event => {
                          const tempIds = tempFilteredIds;
                          if (event.target.checked) {
                            if (!tempIds.includes(rt.id)) {
                              tempIds.push(rt.id);
                            }
                          } else {
                            const index = tempIds.indexOf(rt.id);
                            if (index > -1) {
                              tempIds.splice(index, 1);
                            }
                          }
                          setTempFilteredIds([...tempIds]);
                        }}
                      />
                    }
                    label={<LanguageString languageString={rt.name} />}
                  />
                </Grid>
              );
            })}
            <Grid item xs={12} md={4} style={{ borderBottom: '1px solid #ccc' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={tempFilteredIds.length === rocTypes?.length}
                    value="primary"
                    onChange={event => {
                      if (event.target.checked) {
                        setTempFilteredIds(rocTypes?.map(rt => rt.id) || []);
                      } else {
                        setTempFilteredIds([]);
                      }
                    }}
                  />
                }
                label={<LanguageString groupName="ROC" resourceName="ROC_FILTERS" defaultText="Select All"/>}
              />
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};
export default RecordOfContactFilterDialog;
